import * as prismicH from '@prismicio/helpers'
import { headerCase } from 'change-case'
import Head from 'next/head'
import prismic from 'services/prismic'

import collectionToCollectionCardProps from 'converters/collectionToCollectionCardProps'

import CollectionHeader from 'components/CollectionHeader'
import Divider from 'components/Divider'
import SimpleCollectionCard from 'components/SimpleCollectionCard'
import Spacer from 'components/Spacer'

import { Column, Columns, Root } from './[id].style'

export default function CollectionsByCategory({ title, collections, document }) {
  return (
    <>
      <Head>
        <title>{title} - The Armoury</title>
      </Head>
      <Root>
        <CollectionHeader
          title={title}
          description={prismicH.asHTML(document.data.description)}
          imageUrl={document.data.image?.url}
        />
        <Spacer y={8} />
        <Divider />
        <Spacer y={8} />
        <Columns>
          {collections.map(collectionToCollectionCardProps).map((props) => (
            <Column key={props.handle}>
              <SimpleCollectionCard {...props} />
            </Column>
          ))}
        </Columns>
      </Root>
    </>
  )
}

export async function getServerSideProps({ params }) {
  const title = headerCase(params.id)
  const document = await prismic.getByUID('shop_category_page', params.id)

  const collections = await (await fetch(`${process.env.API_URI}/collections/?category=${title}`)).json()

  return {
    props: {
      collections,
      document,
      title,
    },
  }
}
